import http from "@/axios/http-common";
import { TrackingRegister } from "@/types/tracking_register";

export default {
  async getByRegister(register: string | number): Promise<TrackingRegister> {
    const resp = await http.getData(`/register/${register}/tracking`);
    return resp.data.data;
  }
};
